import { createStyles, makeStyles } from '@mui/styles';

export const useStyles = makeStyles(() =>
	createStyles({
		formRoot: {
			height: '100%',
			width: '100%',
			'& .MuiTextField-root': {
				marginTop: '3rem',
				marginLeft: '0rem',
				marginRight: '1rem',
			},
		},
	}),
);
